import flowPlaceholder from '../../public/placeholders/pirate-2d-not-claimed.jpg';
import claimPlaceholder from '../../public/placeholders/claim-pirate-placeholder.jpg';
export const imgsPlaceholders = {
  ethImgUrl: '',
  flowImgUrl: flowPlaceholder.src,
  flowTransparentImgUrl: flowPlaceholder.src,
}

export default class Pirate
{
  constructor(model)
  {
    Object.assign(this, model);
  }

  tokenName()
  {
    return `POTM #${this.tokenId}`
  }

  getRanking()
  {
    if(!this.ranking) return 0;
    return this.ranking;
  }

  customName(blockchain)
  {
    const customName = this[`${blockchain}CustomName`]
    if(!global.claimEnabled || !customName || customName.status === "rejected" ) return "";

    return customName.value;
  }

  composedName(blockchain, includeToken=false)
  {
    const customName = this.customName(blockchain);
    const tokenName = this.tokenId;

    if(!includeToken && customName) return customName;
    return customName ? `${customName} #${tokenName}` : `#${tokenName}`;
  }

  price(blockchain)
  {
    const price = this[`${blockchain}Price`]
    return price || 0;
  }

  formattedPrice(blockchain) {
    const price = this[`${blockchain}Price`]
    return price ? Math.floor(price * 1000) / 1000 : 0;
  }

  imageUrl(blockchain, transparent=false, useClaimPlaceholder=false)
  {
    const claimed = this[`${blockchain}Claimed`];
    const nameSuffix = transparent ? "TransparentImgUrl" : "ImgUrl";

    if(blockchain === 'flow' && !global.claimEnabled) return imgsPlaceholders[`${blockchain}${nameSuffix}`];

    if(!claimed && useClaimPlaceholder) return claimPlaceholder.src;

    const imageUrl = this[`${blockchain}${nameSuffix}`]
    return claimed && imageUrl || imgsPlaceholders[`${blockchain}${nameSuffix}`];
  }

  getCardAttrs(blockchain, transparent=false, useClaimPlaceholder=false){
    const pirateName = this.customName(blockchain);
    const imageUrl = this.imageUrl(blockchain, transparent, useClaimPlaceholder);
    const piratePrice = this.price(blockchain);
    const { tokenId } = this;

    return { pirateName, tokenId, imageUrl, piratePrice, blockchain };
  }

  wasClaimed = blockchain => this[`${blockchain}Claimed`]

  claimedRecord = () => this.claimedRecords.find(({ blockchain, payload }) => {
    const { transaction } = payload || {};
    return blockchain === 'flow' && Object.keys(transaction).length;
  });

  flowClaimTxId = () => {

    // Record for flow with payload
    const claimRecord = this.claimedRecord();

    if(!claimRecord) return '';

    // Find minted event
    const { transaction } = claimRecord.payload;
    if(!Array.isArray(transaction.events)) return '';

    const event = transaction.events.find((event) => (event.type || '').includes("Minted"));    
    return event?.transactionId || '';
  }

  claimFlowScanUrl = () => {
    const tx = this.flowClaimTxId();
    return tx && `${process.env.NEXT_PUBLIC_FLOW_SCAN_URL}/transaction/${tx}` || '';
  }
}